import React from "react";
import { ArrowRight, Truck } from "lucide-react";
import Logo from "../Assets/NSIRLOGO.png";
const Hero = () => {
  return (
    <div id="home" className="relative min-h-screen">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat transform transition-transform duration-700 hover:scale-105"
        style={{
          backgroundImage:
            'url("https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&q=80")',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/50"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-12 min-h-screen flex items-center">
        <div className="text-white max-w-3xl animate-slide-in">
          <div className="flex items-center mb-6 animate-float">
            <img className="logoImg" src={Logo} alt="Logo"></img>{" "}
            <span className="text-2xl font-bold">
              New Southern India Roadlines
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Your Trusted Partner in
            <span className="text-[#F80D01]"> Transportation</span> Excellence
          </h1>
          <p className="text-xl mb-8 text-gray-200">
            Delivering reliability, efficiency, and peace of mind across
            Southern India with our premium logistics solutions.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              className="group inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#F80D01] hover:bg-red-700 transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
            >
              Get Started
              <ArrowRight className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#services"
              className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white hover:text-gray-900 transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
            >
              Our Services
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
